'use strict';

import Vue from 'vue';

export function loadWidget(element, config) {
    if (window && !window.usePrototypeWidgets) {
        Vue.component(element, config);
    }
}
